<!-- eslint-disable -->
<template>
  <div v-show="C_isVisible" class="panel-container">
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-sound" 
        :class="{active: C_isActiveState}"
        @mousedown="eventMouseDown(P_buttonOneId, P_buttonOneMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonOneId, P_buttonOneMakeSingleEvent)"
        @click="eventMouseClick(P_buttonOneId, P_buttonOneMakeSingleEvent)"
      ></a>
    </div>
    <div class="panel-buttons-divider"></div>
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-decrease"
        @mousedown="eventMouseDown(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonTwoId, P_buttonTwoMakeSingleEvent)"
        @click="eventMouseClick(P_buttonThreeId, P_buttonTwoMakeSingleEvent)"
      ></a>
    </div>
    <div class="panel-buttons-divider"></div>
    <div class="panel-volume-container">
      <p :style="C_volumeStyle">{{C_volumeOutput}}</p>
    </div>
    <div class="panel-buttons-divider"></div>
    <div class="panel-button-container">
      <a 
        class="panel-button panel-button-increase"
        @mousedown="eventMouseDown(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
        @click="eventMouseClick(P_buttonThreeId, P_buttonThreeMakeSingleEvent)"
      ></a>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    'P_buttonOneId',
    'P_buttonOneMakeSingleEvent',
    'P_buttonTwoId',
    'P_buttonTwoMakeSingleEvent',
    'P_buttonThreeId',
    'P_buttonThreeMakeSingleEvent',
    "P_text",
    "P_fontSize",
    "P_fontWeight",
    "P_fontColor",
    'P_customCss'
  ],
  data () {
    return {
      DV_soundOFF: false
    }
  },
  mixins: [bi10GridComponent],
  computed: {
    C_volumeOutput() {
      const CI = this
      return CI.P_text || '--%'
    },
    C_volumeStyle() {
      const CI = this
      let customCSS = {
        height: '100%',
        width: '100%'
      }
      customCSS["fontSize"] = CI.P_fontSize ? CI.P_fontSize : '2.4rem'
      customCSS["fontWeight"] = CI.P_fontWeight ? CI.P_fontWeight : 'normal'
      customCSS["color"] = CI.P_fontColor ? CI.P_fontColor : 'white'
      return customCSS;
    }
  }
}
</script>

<style lang="less" scoped>
.panel-container {
  display: flex;
  padding: 6px;
  height: 100%;
  width: 100%;
  .panel-button-container {
    width: 100%;
    height: 100%;
    .panel-button {
      display: block;
      height: 100%;
      width: 100%;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.panel-button-sound {
        background-image: url(/dynamic/images/b1/NU_GUI/sound-on.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/sound-on.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
        &.active {
          background-image: url(/dynamic/images/b1/NU_GUI/sound-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-red.png);
          &:active {
            background-image: url(/dynamic/images/b1/NU_GUI/sound-off-red-line.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
          }
        }
      }
      &.panel-button-decrease {
        background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/decrease.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
      &.panel-button-increase {
        background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button.png);
        background-size: 90%, cover;
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/increase.png), url(/dynamic/images/b1/NU_GUI/square-button-pressed.png);
        }
      }
    }
  }
  .panel-volume-container {
    align-self: center;
    margin-left: 20px;
    margin-right: 20px;
    white-space: nowrap;
  }
  .panel-buttons-divider {
    width: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/NU_GUI/GSoundPanel.vue